// app/javascript/controllers/sort_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "up", "down"]
  static values  = { storageKey: String }
  static params  = ["sortKey"]

  connect() {
    this.key = this.storageKeyValue || "sortOrder"
    this.loadOrder()
    this.applyOrder()
    this.updateButtonVisibility()
  }

  // --------------------------------------------------------------------
  // UI actions (called from DOM, passing sortKey as param)
  // --------------------------------------------------------------------

  moveUp(event) {
    const key = event.params.sortKey || event.target.closest("button")?.dataset.sortKeyParam
    this.move(key, -1)
  }

  moveDown(event) {
    const key = event.params.sortKey || event.target.closest("button")?.dataset.sortKeyParam
    this.move(key, +1)
  }

  // --------------------------------------------------------------------
  // Helpers
  // --------------------------------------------------------------------

  get keysFromDom() {
    return this.itemTargets.map(el => el.dataset.sortKey)
  }

  findItem(key) {
    return this.itemTargets.find(el => el.dataset.sortKey === key)
  }

  loadOrder() {
    const saved = window.localStorage.getItem(this.key)
    const domKeys = this.keysFromDom

    if (!saved) {
      this.order = domKeys
      return
    }

    const savedOrder = saved.split(",")

    this.order = [
      ...savedOrder.filter(k => domKeys.includes(k)),
      ...domKeys.filter(k => !savedOrder.includes(k)),
    ]
  }

  saveOrder() {
    window.localStorage.setItem(this.key, this.order.join(","))
  }

  move(key, delta) {
    const index = this.order.indexOf(key)
    if (index === -1) return

    const newIndex = index + delta
    if (newIndex < 0 || newIndex >= this.order.length) return

    // reorder the array
    this.order.splice(index, 1)
    this.order.splice(newIndex, 0, key)

    this.applyOrder()
    this.saveOrder()
  }

  applyOrder() {
    this.order.forEach(key => {
      const el = this.findItem(key)
      if (el) this.element.appendChild(el)
    })
    this.updateButtonVisibility()
  }

  updateButtonVisibility() {
    this.itemTargets.forEach((item, index) => {
      item.querySelector("[data-sort-up-target]")?.classList.toggle("invisible", index === 0)
      item.querySelector("[data-sort-down-target]")?.classList.toggle("invisible", index === this.itemTargets.length - 1)
    })
  }
}
